import { Timeline } from "antd";

import { BaseTimelineProps } from "@/components_v2/Timeline/types";

const BaseTimeline = (props: BaseTimelineProps) => {
  return <Timeline {...props} />;
};

export default BaseTimeline;
